// Display labels for normalised discounts. Labels only: amounts in the cart always come from the engine.
import CommonService from "../../../shared/services/commonService";
import { BuyRequirement, Discount, Minor, toMajor } from "../../../redux/utils/discountEngine";

export const formatMinor = (currencySymbol: string, amount: Minor) =>
	CommonService.currencyStandard(currencySymbol, toMajor(amount).toString())

export const describeBuy = (buy: BuyRequirement[]) =>
	buy.map((item) => `${item.quantity} × ${item.type === "CATEGORY" ? `any ${item.name} item` : item.name}`).join(" + ")

export const describeDiscount = (discount: Discount, currencySymbol: string): { tag: string, title: string, description: string } => {
	switch (discount.kind) {
		case "AUTOMATIC": {
			const value = discount.valueType === "PERCENTAGE" ? `${discount.value}% OFF` : `${formatMinor(currencySymbol, discount.value)} OFF per unit`
			const scope = discount.scope.type === "BRAND"
				? ` on ${discount.scope.brandName || "this brand"}`
				: discount.scope.type === "CATEGORY" ? ` on ${discount.scope.categoryName || "this category"}` : ""
			const cap = discount.cap != null ? `, up to ${formatMinor(currencySymbol, discount.cap)} per order` : ""
			return { tag: "AUTOMATIC", title: `${discount.title} (${value})`, description: `Applied automatically${scope}${cap}` }
		}
		case "BUY_X_GET_Y": {
			const get = discount.get.type === "CATEGORY" ? `${discount.get.quantity} × any ${discount.get.name} item` : `${discount.get.quantity} × ${discount.get.name}`
			const percent = discount.get.percent >= 100 ? "FREE" : `${discount.get.percent}% off`
			return { tag: "BUY X GET Y", title: discount.title, description: `Buy ${describeBuy(discount.buy)}, get ${get} ${percent}. Claim it from the cart.` }
		}
		case "PAY_X_GET_FREE":
			return {
				tag: "FREE GIFT",
				title: discount.title,
				description: `Spend ${formatMinor(currencySymbol, discount.threshold)} or more, get ${discount.freeProducts.map((item) => item.name).join(", ")} free`,
			}
	}
}
